module.exports = __webpack_public_path__ + "media/intro_illustration.807870aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro_illustration.png
// module id = ./src/assets/intro_illustration.png
// module chunks = 0